<ps-ui-modal class="viewModal">
  <ps-ui-modal-body>
    <div class="col-xs-12 col-sm-8 col-md-8 col-md-offset-2 left-margin">
      <h4 class="buyer-link-header">Latest uploads</h4>
      <ng-container *ngFor="let item of buyerEntryLinks; let last = last">
        <p class="buyer-entry-link">{{ item }}{{ last ? '' : ',' }}</p>
      </ng-container>
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer> </ps-ui-modal-footer>
</ps-ui-modal>
